import {
  Document,
  RemoveFilesFromDocumentBody,
} from "@syadem/kairos-citizen-js";
import { Service } from "../service";
import { ActionResult } from "../../actionResult";
import { Apis } from "../../network/apis";

interface Payload {
  healthRecordId: string;
  documentId: string;
  fileIds: string[];
}

export class RemoveDocumentFilesService implements Service<Payload, Document> {
  constructor(
    private readonly apis: Apis
  ) { }

  async call({
    healthRecordId,
    documentId,
    fileIds,
  }: Payload): Promise<ActionResult<Document>> {

    const body: RemoveFilesFromDocumentBody = {
      fileIds,
    };

    const apiDocument = await this.apis.documentApi.removeFilesFromDocument(
      healthRecordId,
      documentId,
      body,
    );

    return {
      type: "success",
      value: apiDocument,
    };
  }
} 